import { UserRecordDto } from '@splitsecondconnect/ultramarine-shared';
import { OperatorUserModel } from '../models';

/**
 * Maps the operator session user onto the menu card.
 */
export function operatorUserDtoToModel(
  userDto: UserRecordDto,
): OperatorUserModel {
  return {
    id: userDto.id,
    email: userDto.email,
    username: userDto.username,
    usernameShort: userDto.username.split('@')[0],
    authProviderName: userDto.authProviderName,
    authProviderUserId: userDto.authProviderUserId,
    status: userDto.status,
    notes: userDto.notes,
    type: userDto.type,
    userRoleName: userDto.userRoleName,
    lastLoginAt: userDto.lastLoginAt,
    lastLoginIp: userDto.lastLoginIp,
    tenantOrgId: userDto.tenantOrgId,
    tenantName: userDto.tenantName,
    tenantStatus: userDto.tenantStatus,
    featureFlags: userDto.featureFlags ?? [],
  };
}
